import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import styled from 'styled-components';

// IMPORT FUNCTIONS
import getUrl from  "./utils/functions/getUrl";

// IMPORT COMPONENTS
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Dashboard from './components/Dashboard/Dashboard';
import Album from './components/Album/Album';
import Login from './components/Login/Login';
import SignIn from './components/SignIn/SignIn';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import CreateNewPassword from './components/CreateNewPassword/CreateNewPassword';
import Logout from './components/Logout/Logout';
import PageNotFound from './components/PageNotFound/PageNotFound';
import ModalImage from './components/Dashboard/components/Modal/ModalImage';

// css
import './App.css';


function App() {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);

  const userData = sessionStorage.userData ? JSON.parse(sessionStorage.userData) : null;
  console.log('userData:->');
  console.log(userData);

  const [toggleModal, setToggleModal] = useState(false);
  const [toggleModalImage, setToggleModalImage] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [logged, setLogged] = useState(false);
  const [showDeletedImages, setShowDeletedImages] = useState(false);

  const [ inAlbumOnly, setInAlbumOnly ] = useState(false)

  // 
  // USEEFFECT(S)
  // 


  // DOCUMENT TITLE
  useEffect(()=>{
    document.title = 'PictureViever';

    userData && setLogged(true)
  },[]);


  useEffect(()=>{
    console.log(`logged: ${logged}`);
    console.log(`toggleModal: ${toggleModal}`);
  },[logged, toggleModal]);


  // 
  // FUNCTIONS
  // 

  // 
  // 
  // 
  const handleLogged = (bool) => {
    console.log(`handleLogged()`);

    console.log(`bool: ${bool}`);

    setLogged(bool)
  }

  // 
  // 
  // 
  const handleImageModalExpand = (image) => {
    console.log(`handleExpand()`);

    console.log(`image:->`);
    console.log(image);

    // console.log(`images[${idx}]:->`);
    // console.log(images[idx]);

    setImageData(image);
    setToggleModalImage(true);

  }

  return (
    <Wrapper id="app-wrapper">
      <Router>

        <Header 
          logged={logged} 
          setToggleModal={setToggleModal}
          showDeletedImages={showDeletedImages} 
          setShowDeletedImages={setShowDeletedImages}
          setInAlbumOnly={setInAlbumOnly}
          inAlbumOnly={inAlbumOnly}
        />

        <Routes>

          <Route exact path={BASE_URL +'/'} element={<Home logged={logged} />} />
          <Route 
            exact path={BASE_URL +'/dashboard'} 
            element={
              <Dashboard  
                logged={logged} 
                toggleModal={toggleModal} 
                setToggleModal={setToggleModal} 
                handleImageModalExpand={handleImageModalExpand} 
                showDeletedImages={showDeletedImages} 
                setShowDeletedImages={setShowDeletedImages}
                inAlbumOnly={inAlbumOnly}

              /> 
            } 
          />
          <Route 
            exact path={BASE_URL +'/album'} 
            element={
              <Album 
                handleImageModalExpand={handleImageModalExpand}
              />} 
          />
          <Route exact path={BASE_URL +'/signin'} element={<SignIn />} />
          <Route exact path={BASE_URL +'/login'} element={<Login logged={handleLogged} />} />
          <Route exact path={BASE_URL +'/logout'} element={<Logout logged={handleLogged} />} />
          <Route exact path={BASE_URL +'/forgot-password'} element={<ForgotPassword />} />
          <Route exact path={BASE_URL +'/create-new-password'} element={<CreateNewPassword />} />
          <Route path='*' exact={true} element={<PageNotFound />} />

        </Routes>
      </Router>

      {/* display image */}
      {toggleModalImage && <ModalImage closeModal={setToggleModalImage} imageData={imageData} />}

    </Wrapper>
  );
}

export default App;

const Wrapper = styled.div `
  margin: 0 auto;
  width: 100%;
  font-size: 2rem;
  color: #d1d1d1;
  min-height: 100vh;
  background-color: rgba(0,0,0,0.5);

  display: flex;
  flex-direction: column;
  align-items: center;
  
  
`;
